import { render, staticRenderFns } from "./ConfiguracoesPainel.vue?vue&type=template&id=180979a9"
import script from "./ConfiguracoesPainel.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesPainel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports